export default __webpack_public_path__ + "static/media/zest.5d8cd0d4.svg";